import React, { useState } from "react";
import axios from "axios";
import { X, Download, Copy, Check, Share2 } from "lucide-react";

// One sheet, four ways out: WhatsApp, X, copy the link, save the image.
export const ShareSheet = ({ card, onClose }) => {
  const [copied, setCopied] = useState(false);
  if (!card) return null;

  const msg = `${card.text} ${card.share_url}`;
  const open = (url) => window.open(url, "_blank", "noopener");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(msg);
      setCopied(true);
      setTimeout(() => setCopied(false), 2200);
    } catch { /* clipboard blocked — the link is visible on screen anyway */ }
  };

  const btn = {
    display: "flex", alignItems: "center", justifyContent: "center", gap: "8px",
    padding: "13px 14px", borderRadius: "12px", fontSize: "0.88rem", fontWeight: 700,
    cursor: "pointer", border: "1px solid rgba(255,255,255,0.14)", color: "#fff",
    background: "rgba(255,255,255,0.06)", transition: "background-color .2s, transform .2s",
  };

  return (
    <div data-testid="share-sheet" onClick={onClose} style={{
      position: "fixed", inset: 0, zIndex: 1200, background: "rgba(6,0,14,0.82)",
      backdropFilter: "blur(10px)", display: "flex", alignItems: "center",
      justifyContent: "center", padding: "18px",
    }}>
      <div onClick={(e) => e.stopPropagation()} className="glass-card animate-fadeInUp" style={{
        width: "100%", maxWidth: "420px", padding: "18px", maxHeight: "92vh", overflowY: "auto",
        border: "1px solid rgba(255,209,102,0.3)",
      }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
          <span className="font-cinzel" style={{ color: "#FFD166", fontSize: "1rem" }}>Share your timeline</span>
          <button data-testid="share-close-btn" onClick={onClose} style={{ background: "none", border: "none", color: "rgba(255,255,255,0.55)", cursor: "pointer" }}>
            <X size={18} />
          </button>
        </div>

        <img data-testid="share-card-image" src={card.image_url} alt="My AstroFate Life Timeline"
          style={{ width: "100%", borderRadius: "14px", border: "1px solid rgba(255,209,102,0.35)", display: "block", marginBottom: "14px" }} />

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "9px" }}>
          <button data-testid="share-whatsapp-btn" style={{ ...btn, background: "rgba(37,211,102,0.16)", borderColor: "rgba(37,211,102,0.4)" }}
            onClick={() => open(`https://wa.me/?text=${encodeURIComponent(msg)}`)}>WhatsApp</button>
          <button data-testid="share-x-btn" style={btn}
            onClick={() => open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(card.text)}&url=${encodeURIComponent(card.share_url)}`)}>Post on X</button>
          <button data-testid="share-copy-btn" style={btn} onClick={copy}>
            {copied ? <><Check size={15} /> Copied</> : <><Copy size={15} /> Copy link</>}
          </button>
          <a data-testid="share-download-btn" href={`${card.image_url}?dl=1`} style={{ ...btn, textDecoration: "none" }}>
            <Download size={15} /> Save image
          </a>
        </div>

        <p style={{ color: "rgba(255,209,102,0.85)", fontSize: "0.78rem", marginTop: "12px", lineHeight: 1.6 }}>
          ✦ Every new friend who opens this card earns you 1 free AI question (up to 5).
        </p>
        <p style={{ color: "rgba(255,255,255,0.4)", fontSize: "0.74rem", marginTop: "8px", lineHeight: 1.6 }}>
          The card shows your first name and chart signs only — never your birth date, time or place.
        </p>
      </div>
    </div>
  );
};

// Creates the card server-side, then opens the sheet.
export const useShareCard = (API) => {
  const [card, setCard] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const create = async (payload) => {
    setBusy(true); setError("");
    try {
      const r = await axios.post(`${API}/share/card`, payload, { withCredentials: true });
      setCard(r.data);
    } catch (e) {
      setError(e.response?.data?.detail || "Could not create the card. Please try again.");
    }
    setBusy(false);
  };
  return { card, busy, error, create, close: () => setCard(null) };
};

export const ShareIcon = Share2;
export default ShareSheet;
